var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Menu',{attrs:{"mode":"horizontal","active-name":_vm.current}},[_c('div',{staticClass:"layout-nav"},[_c('MenuItem',{attrs:{"name":"1","to":"/"}},[_c('Icon',{attrs:{"type":"md-search"}}),_vm._v(" Log查詢 ")],1),_c('MenuItem',{attrs:{"name":"2","to":"/deploy"}},[_c('Icon',{attrs:{"type":"md-search"}}),_vm._v(" Deployment狀態 ")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }